module.exports = __webpack_public_path__ + "static/mark_1-7e63815371441fd5dafaf731d35d0ce0.png";